import React, { useState } from "react";
import PropTypes from "prop-types";

import { Icon } from "@/common/components/primitives/icon";

import styles from "./dropdowntarget.css";

import DownArrowIcon from "./small-down.svg";
import ReplyCloseIcon from "./ReplyClose.svg";
import HorizontalMoreIcon from "./HorizontalMore.svg";

export const DROPDOWNTARGET_SIZE = {
  MEDIUM: "medium",
  SMALL: "small",
  LARGE: "large"
};

export const DROPDOWNTARGET_TYPE = {
  ARROW: "arrow",
  MORE: "more",
  NONE: "none",
  MINIMAL_ARROW: "minimalArrow",
  MINIMAL_MORE: "minimalMore",
  MINIMAL_NONE: "minimalNone"
};

export function DropdownTarget(props) {
  const {
    isOpen = false,
    id,
    label,
    children,
    className,
    size = DROPDOWNTARGET_SIZE.LARGE,
    type = DROPDOWNTARGET_TYPE.ARROW,
    onSearch,
    onClick,
    onLabelClick,
    onArrowClick,
    onClear,
    readOnly = false,
    disabled = false,
    searchText = "",
    placeholder = ""
  } = props;
  const [isEditing, setIsEditing] = useState(false);
  return (
    <div>
      {label && (
        <label
          className={`${styles.label} small`}
          htmlFor={id}
          id={`${id}_label`}
        >
          {label}
        </label>
      )}
      <div
        className={`${styles.dropdowntarget} ${isOpen ? styles.open : ""} ${
          styles[size]
        } ${styles[type]} ${className} ${
          size === DROPDOWNTARGET_SIZE.SMALL ? `smallplus` : ""
        } ${readOnly && styles.readOnly} ${disabled && styles.disabled}`}
        onClick={onClick}
        tabIndex={0}
        onFocus={() => {
          if (onSearch) setIsEditing(true);
        }}
        id={id}
      >
        <div className={`${styles.content}`} onClick={onLabelClick}>
          {onSearch && isEditing ? (
            <input
              type="text"
              className={styles.editable}
              autoFocus={true}
              onBlur={() => {
                setIsEditing(false);
              }}
              onChange={(e) => {
                onSearch(e.target.value);
              }}
              placeholder={placeholder}
              {...(searchText && { value: searchText })}
            />
          ) : (
            children
          )}
        </div>
        {!!onClear && (
          <div className={styles.clear}>
            <Icon onClick={onClear}>
              <ReplyCloseIcon />
            </Icon>
          </div>
        )}
        {!readOnly &&
          !disabled &&
          (type === DROPDOWNTARGET_TYPE.ARROW ||
            type === DROPDOWNTARGET_TYPE.MINIMAL_ARROW) && (
            <div className={styles.arrow} onClick={onArrowClick}>
              <DownArrowIcon />
            </div>
          )}
        {!readOnly &&
          !disabled &&
          (type === DROPDOWNTARGET_TYPE.MORE ||
            type === DROPDOWNTARGET_TYPE.MINIMAL_MORE) && (
            <div className={styles.more} onClick={onArrowClick}>
              <HorizontalMoreIcon />
            </div>
          )}
      </div>
    </div>
  );
}

DropdownTarget.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  /**
   * Should be of Type DROPDOWNTARGET_SIZE
   */
  size: PropTypes.string,
  onSearch: PropTypes.func,
  type: PropTypes.string,
  onClick: PropTypes.func,
  onLabelClick: PropTypes.func,
  onArrowClick: PropTypes.func,
  onClear: PropTypes.func,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  searchText: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string
};
